import React from 'react';
import { useAuth0 } from 'status/hooks';
import { Navigate } from 'react-router-dom';
import { encode } from 'status/utilities/hash';
import contains from 'status/utilities/contains';
import LogRocket from 'logrocket';
const EmployeeRedirect = () => {
    const { userMeta } = useAuth0();
    const applicationPermissions = userMeta.applicationPermissions;
    if (userMeta.empNumGPFed && userMeta.smallMid) {
        let formatted = userMeta.empNumGPFed.replace(/-/g, '');
        const id = encode(formatted);
        return <Navigate replace to={`/status/employee/${id}/coveragedetail`}/>;
    }
    // User has an emp number so simply redirect to the landing page
    if (userMeta.empNumS1) {
        const id = encode(userMeta.empNumS1);
        return <Navigate replace to={`/status/employee/${id}/coveragedetail`}/>;
    }
    // USAA EE specific
    //route USAA EE sso users without s1 or gpFed empNums to 'partial' version of coverage details
    // User is a sso user so set the emp number to "id-empId" and encode it
    if (userMeta.ssoUser && userMeta.ssoCargo.employeeId && (userMeta.customerInternalName === "USAA")) {
        const id = encode(userMeta.ssoCargo.employeeId, true);
        return <Navigate replace to={`/status/employee/${id}/coveragedetail`}/>;
    }
    if (userMeta.ssoUser && userMeta.ssoCargo.employeeId) {
        LogRocket.log('SSO user without s1 or gp empNum routed to find my info');
        return <Navigate replace to={'/status/employee/findmyinfo'}/>;
    }
    // Special case for users that
    // 1. Have statusEE.eoiStatus enabled
    // 2. Dont have statusEE.claimLeaveStatus
    // This if check may change if more permissions are added
    // Basically the if statment can be read as follows:
    // If the user is only configured to view EOI and nothing else
    // Then send them to the EOI page
    if (!contains(applicationPermissions, 'statusEE.claimLeaveStatus') &&
        contains(applicationPermissions, 'statusEE.eoiStatus')) {
        return <Navigate replace to={'/status/employee/eoi'}/>;
    }
    // If we get here we dont have enough info to give the user data
    // so we send them off to find themselves :)
    return <Navigate replace to={'/status/employee/findmyinfo'}/>;
};
export default EmployeeRedirect;
